angular.module('qbePortal.rapidEstimate.bike')
	.controller('BikeRapidEstimateController', [
		'$scope',
		'$state',
		'userInputRepository',
		'labelService',
		'portalServiceWrapper',
		'quoteOptions',
		'Util',
		'serviceResponseRepository',
		'gtmService',
		'$sce',
		function($scope, $state, userInputRepository, labelService, portalServiceWrapper, quoteOptions, util, serviceResponseRepository, gtmService, $sce) {
			var vm = this;
			vm.formData = {};
			vm.promoCode = util.getQueryStringByName(window.location, 'promotionalCode') ;
			console.log( vm.promoCode ) ; 
			vm.elementName = 'Form Controller';
			vm.validationErrors = null;
			vm.sections = {};

			vm.initPage= function() {
				util.dispatchCustomEvent('register-labels');
				vm.formData = userInputRepository.get({
					bikeForm: {
						tellUsMore: {
							promotionalCode: vm.promoCode
						}
					}
				});
			}

			

			vm.registerSection = function (name, init, getValueFn) {
				vm.sections[name] = getValueFn;
			}

			// Submit form to get quickQuote
			vm.submit = function(event, form) {
				event.preventDefault();

				gtmService.trackEvent('rapid-estimate-submit') ;

				vm.showErrorSummary = false;
				isInvalid = form.$invalid;

				if (isInvalid) {
					$scope.$broadcast('broadcast-field-errors');
					vm.showErrorSummary = true;
					$scope.$broadcast('reset-field-errors');
					scrollViewTo($('#combinedValidationListing')) ;
					console.info(' Form is not valid');
					return;
				}

				$scope.$root.$broadcast('loading-animation-start');

				// Populate formData
				var formData = {};
				for (var key in this.sections) {
					formData[key] = this.sections[key]();
				}
				var now = moment().tz("Australia/Sydney").format('DD/MM/YYYY');
				formData.bikeForm.getStarted = {
					personOrCompany: 'person',
					policyStartDate: now
				};
				formData.bikeForm.rider.riders = [];
				formData.bikeForm.rider.riders[0] = {
					person: util.deepClone(formData.bikeForm.rider)
				};

				if(formData.bikeForm.tellUsMore) {
					formData.email = formData.bikeForm.tellUsMore.email;
					formData.bikeForm.promotionalCode = {
						promotionalCode: formData.bikeForm.tellUsMore.promotionalCode
					};
				}

				userInputRepository.update(formData);

				portalServiceWrapper.updateQuote(formData);

				var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep('rapidEstimate') ;

				portalServiceWrapper.getQuickQuote(quickQuoteOptions.permutations, quickQuoteOptions.rules)
					.then(function(resp) {
						vm.applyFormPath = this.endpointUrls.estimateRedirect;
						var quoteResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
						serviceResponseRepository.update('rapidEstimate' , quoteResults ) ;
						$scope.$root.$broadcast('process-rapid-estimates', {
							formData: formData,
							results : quoteResults,
						});
					})
					.catch(function(err) {
						$scope.$root.$broadcast('error', {
							errorMessage: 'getQuickQuote error',
							response: err
						});
					});

			};

			/**
			 * Scrolls a field into view when an error is clicked
			 * @param {Object} error                    Error object with key `name`
			 */
			vm.showInView = function (error) {
				//console.log(error);
				scrollViewTo($('[name="' + error.name + '"]')) ;
			}

			function scrollViewTo($element) {
				var offset = $element.offset();
				if ( offset ) {
					$('html, body').animate({
						scrollTop: (offset.top - 50),
						scrollLeft: offset.left
					});
				}
			}

			vm.getSectionDescriptionFor = function (fieldName) {
				return $sce.trustAsHtml(labelService.getSectionDescriptionFor(fieldName));
			}

			// Scroll to estimates once they're loaded
			$scope.$root.$on('show-rapid-estimates', function() {
				vm.showRapidEstimatesPanel = true;
			});

			$scope.$root.$on('rapid-estimates-panel-initialised', function() {
		 		var rapidEstimateResults = serviceResponseRepository.getLastResponseFrom('rapidEstimate') ;
				if ( rapidEstimateResults ) {
					vm.applyFormPath = this.endpointUrls.estimateRedirect;
					$scope.$root.$broadcast('process-rapid-estimates', {
						results: rapidEstimateResults,
						formData: userInputRepository.get()
					});
				}
			});
		}
	]);
